import { render, staticRenderFns } from "./MyHealth.vue?vue&type=template&id=db64ab26&scoped=true&"
import script from "./MyHealth.vue?vue&type=script&lang=js&"
export * from "./MyHealth.vue?vue&type=script&lang=js&"
import style0 from "./MyHealth.vue?vue&type=style&index=0&id=db64ab26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db64ab26",
  null
  
)

export default component.exports